import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { DateIncludedInAccountingQuery, DateIncludedInAccountingQueryHandlerBase } from '@skylab-shared/business';
export { DateIncludedInAccountingQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(DateIncludedInAccountingQuery)
@Wrapper(DateIncludedInAccountingQueryHandlerBase)
export class DateIncludedInAccountingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
